import * as React from "react";
import { SharedGitCredentialForm } from "./SharedGitCredentialForm";
interface CreateGitCredentialPageProps {
    spaceId: string;
}
export function CreateGitCredentialPage({ spaceId }: CreateGitCredentialPageProps) {
    return <SharedGitCredentialForm spaceId={spaceId} create={true}/>;
}
